/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/todo-list';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 260,
    },
    columnWidth: {
        taskId: 70,
        toDotypeAndSubType: 160,
        addedDate: 70,
        dueDate: 70,
        memberName: 120,
        memberId: 100,
        assignee: 120,
        status: 80,
        
        // special columns
        _groupActions: 80, // group actions column
    },
    columnIcons: {},
    filterFlyoutWidths: {
        toDotypeAndSubType: 200,
    },
    valueColors: {
        status: {
            closed: '#59ad00',
            open: '#e7aa00',
        },
    },
    actionIcons: {
        initiateCall: 'hollowPhone'
    },
    highlightRow: 'hasPassedDueDate'
};
